import { render, staticRenderFns } from "./ParcelDataComponent.vue?vue&type=template&id=269f9710&"
import script from "./ParcelDataComponent.vue?vue&type=script&lang=js&"
export * from "./ParcelDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports